<script>
  import {link} from 'svelte-routing'

  document.addEventListener('DOMContentLoaded', () => {

// Get all "navbar-burger" elements
const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

// Check if there are any navbar burgers
if ($navbarBurgers.length > 0) {

  // Add a click event on each of them
  $navbarBurgers.forEach( el => {
    el.addEventListener('click', () => {

      // Get the target from the "data-target" attribute
      const target = document.getElementById(el.dataset.target);

      // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
      el.classList.toggle('is-active');
      target.classList.toggle('is-active');

    });
  });
}

});

</script>

<style>
  .navbar { 
    flex-wrap: wrap;
  }
  .logo {
    margin: auto
  }
  .navbar-brand img {
    margin: .5rem 1rem;
    max-height: 3rem;
  }
  @media(min-width:1024px){  
    .navbar-brand img {
      max-height: 5rem;
    }
    .navbar-brand, .navbar-start { 
      width: 80%;
      justify-content: space-around;
      margin: auto;
      border-bottom: 1px grey solid;
    }
  }
  .navbar-brand, .navbar-start { 
      border-bottom: 1px grey solid;
      align-items: center;
  }
  .navbar-burger{
    margin-left: -52px;
  }
</style>

<nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item logo" use:link href="/">
        <picture>
          <source media="(max-width: 1024px)" srcset="/assets/images/logo_48.webp 1x, /assets/images/logo_80.webp 2x, /assets/images/logo_160.webp 3x" type="image/webp">
          <source media="(min-width: 1025px)" srcset="/assets/images/logo_80.webp 1x, /assets/images/logo_160.webp 2x, /assets/images/logo_240.webp 3x" type="image/webp">
          <source media="(max-width: 1024px)" srcset="/assets/images/logo_48.png 1x, /assets/images/logo_80.png 2x, /assets/images/logo_160.png 3x" type="image/png">
          <source media="(min-width: 1025px)" srcset="/assets/images/logo_80.png 1x, /assets/images/logo_160.png 2x, /assets/images/logo_240.png 3x" type="image/png">
          <img class="image" src="/assets/images/logo_80.png" alt="Sub-Atomic Epoch">
        </picture>
      </a>
  
      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
  
    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <a class="navbar-item" use:link href='/map'>
          Interactive Map
        </a>
  
        <a class="navbar-item">
          Commisions
        </a>
  
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Products
          </a>
  
          <div class="navbar-dropdown">

            <a class="navbar-item">
              Sculptures
            </a>
            <a class="navbar-item">
              Printed Calendar
            </a>
            <a class="navbar-item">
              Jewellry
            </a>
          </div>
        </div>

        <a class="navbar-item">
          About
        </a>
      </div>
  
    </div>
  </nav>